import { Routes, Route } from "react-router-dom";

import { Landing } from "../Homepage/Landing";
import UsersPage from "../Components/UsersPage";
import HistoryPage from "../Components/HistoryPage";
import AdminDash from "../Components/AdminPages/AdminDash";
import NotFound from "../Components/NotFound";
import Signup from "../Homepage/Components/Signup";
import Login from "../Homepage/Components/Login";
import Cart from "../Components/Cart";
import Products from "../Components/Products";
import PaymentsPage from "../Components/PaymentsPage";
export const AllRoute = () => {
  // console.log(this.props.location.pathname);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/product" element={<Products />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/payment" element={<PaymentsPage />} />
      <Route path="/admin_dashboard/*" element={<AdminDash />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
